import { makeStyles } from 'tss-react/mui';

const TAG_HEIGHT_IN_PIXELS = 18;

export const useProductDetailsCombinationColorAndTagsStyles = makeStyles()((theme) => ({
  availabilityTag: {
    height: TAG_HEIGHT_IN_PIXELS,
    paddingInline: theme.spacing(0.25),
  },
  iconTag: {
    height: TAG_HEIGHT_IN_PIXELS,
    paddingInline: theme.spacing(0.5),
  },
}));
